module.exports = __webpack_public_path__ + "img/sticker_5.8912cbff.svg";